export default __webpack_public_path__ + "static/about1-ff0257f00210e25dd981188b632069ba.webp";